module.exports = __webpack_public_path__ + "img/menupoly-utility-icon.509b72c3.png";